var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modelCanvas",attrs:{"id":_vm.containerId}},[(_vm.toolbarEnable)?_c('ModelToolbar',{attrs:{"bench":_vm.benchId,"canvasId":_vm.modelId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }